var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs/Rx';
import { ArrayListMultimap } from './../util/index';
/**
 * Event bus
 */
export let AppBus = class AppBus {
    constructor() {
        this.subscribers = ArrayListMultimap.create();
    }
    // should be but seems like typescript bug:
    // public addSubscription<T>(event: T, handler: (o: Subject<T>) => Subscription): void {
    //     let subject: Subject<T> = Subject.create();
    //     this.subscribers.put(event.constructor.name, subject);
    //     handler(subject);
    // }
    addSubscription(eventName, handler) {
        // should be but seems like rxjs bug:
        // let subject: Subject<T> = Subject.create();
        let subject = new Subject();
        this.subscribers.put(eventName, subject);
        handler(subject);
    }
    publish(event) {
        Observable.from(this.subscribers.get(event.constructor.name))
            .subscribe(subscription => subscription.next(event));
    }
};
AppBus = __decorate([
    Injectable(), 
    __metadata('design:paramtypes', [])
], AppBus);
//# sourceMappingURL=app-bus.js.map